import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { persistor } from "../store";
import { useNavigate } from "react-router-dom";
import AllRoles from "../images/all_roles.png";


const notify = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warning(msg);
        break;
      default:
        toast.error(msg);
    }
  };

////////////////////////// AUTH - Action Creator //////////////////////////

export const login = (data) => {
  return {
    type: "LOGIN",
    payload: data,
  };
};

export const setClient = (data) => {
    return {
      type: "SET_CLIENT",
      payload: data,
    };
  };

export const logout = () => {
  // alert();
  return {
    type: "LOGOUT",
    payload: null,
  };
};
  

////////////////////////// AUTH - Action //////////////////////////

export const Login = async (data) => {
    try {
        const response = await axios.post(process.env.REACT_APP_BACKEND_API_URL+'/user/login/', data, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        
        
          if (response.status === 200 ) {
            sessionStorage.setItem("token", response.data.token);
            sessionStorage.setItem("refresh_token", response.data.refresh);

            // Set Authorization header for axios
            axios.defaults.headers.common["Authorization"] = `Token ${response.data.token}`;

            if(response.data.user){
              sessionStorage.setItem('name', response.data.user.name);
              sessionStorage.setItem('id', response.data.user.id);
              sessionStorage.setItem('profile_picture', response.data.user.picture);
              sessionStorage.setItem('is_admin', response.data.user.is_admin);
              sessionStorage.setItem('userrole', response.data.user.role);

              if(response?.data?.user?.role.length > 1){
                sessionStorage.setItem("currentRole", "All")
                sessionStorage.setItem("currentRoleName", "All Roles")
                sessionStorage.setItem("currentRoleIcon", AllRoles)
              }
              else{
                sessionStorage.setItem("currentRole", response?.data?.user?.role_data[0]?.id)
                sessionStorage.setItem("currentRoleName", response?.data?.user?.role_data[0]?.role_name)
                sessionStorage.setItem("currentRoleIcon", response?.data?.user?.role_data[0]?.role_icon)
              }
              
            }
            return response.data;
        }
    } catch (err) {
        console.log("Error", err);
        notify("Error in login! Try again.", "error");
    }
};
  
export const Logout = (data) => {
    const navigate = useNavigate()

    return async (dispatch) => {
        try {
          const response = await axios.post(process.env.REACT_APP_BACKEND_API_URL+'/user/logout/', data, {
              headers: {
              "Content-Type": "application/json",
              },
          });

          console.log("Response for logout:", response);
          if (response.status === 204) {
              sessionStorage.clear();
              console.log("LOCAL STORAGE", sessionStorage)
              notify("You are successfully logged out.", "success");
              dispatch(logout());
              navigate("/");
          }
        } catch (err) {
          console.log("Error", err);
          dispatch(logout());
          persistor.purge();
        }
    };
};